import { EzEnumeration2 } from '/ezlibrary/enums/EzEnumeration2.js';

/**
 * @public
 * @class
 * @extends {EzEnumeration2}
 * @description
 * The response status from a modal dialog with multiple choice buttons.
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * The following static methods provided by EzEnumeration2 parnet class:
 *      {EnumClass}.ezAsEnum(enumPropertyNameOrValue)
 *      {EnumClass}.ezValueOf(enumPropertyName)
 *      {EnumClass}.ezNameOf(enumPropertyValue)
 *      {EnumClass}.ezEnumData(enumPropertyValue)
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import into non-enumeration classes with:
 *     import {
 *          EzDialogResponseStatus
 *      } from '/ezlibrary/enums/EzEnumerations.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import into other enumeration classes with:
 *     import { EzDialogResponseStatus } from '/ezlibrary/ux/dialogs/EzDialogResponseStatus.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
export class EzDialogResponseStatus extends EzEnumeration2 {
    /**
     * @private @field
     * Stores the singleton instance of this enumeration class.
     * @type {EzDialogResponseStatus}
     */
    static #ezEnumerationSingleton = null;

    /**
     * @static
     * Static Initialization
     */
    static {
        if (null == EzDialogResponseStatus.#ezEnumerationSingleton) {
            EzDialogResponseStatus.#ezEnumerationSingleton = new EzDialogResponseStatus(
                // Enum property names
                [
                    'UNKNOWN',
                    'RESPONSE_PENDING',
                    'OK',
                    'CANCEL',
                    'YES',
                    'NO',
                    'ACCEPT',
                    'AGREE',
                    'CONFIRM',
                    'DECLINE',
                    'CONTINUE',
                    'RETRY',
                    'STOP',
                    'APPROVED',
                    'DECLINED',
                    'SEND',
                    'SENT',
                    'SUBMITTED',
                    'SKIP'
                ],
                // Enum property values (use default (enum property names array))
                null,
                // Enum property optional data (use detail)
                null);
        }
    }
}
